<template>
  <div class="panel-body">
      <div>
          Verify User's Email
      </div>
      <form>

        <v-text-field
        v-model="email"
        :rules="emailRules"
        label="email"
        ></v-text-field>

      <v-btn @click="verify">verify</v-btn>
      <v-btn @click="clear">clear</v-btn>

      </form>
  </div>
</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
  },
  data: () => ({
    email: '',
    emailRules: [
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ]
  }),

  computed: {
  },

  watch: {
  },

  created () {
  },

  methods: {
    async verify () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/verify`

      var body = { 'quberUserName': this.email,
        'emailVerified': true }

      var getResponse = await rh.default.patch(endpoint, body, true).catch(e => {
        this.errors.push(e)
      })
    },
    clear () {

    }
  }
}
</script>
